import createReducer from '../createReducer';
import immutable from '../structure/immutable';

export default createReducer(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/reducer.js
// module id = 1210
// module chunks = 0